var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"redeem-btn",class:_vm.strButtonClass,domProps:{"innerHTML":_vm._s(_vm.strButtonLabel)},on:{"click":function($event){return _vm.clickRedeem()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }